import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable max-len */

/**
The main entry point for Collections.
Referenced by numerous collection.*.liquid templates.
* */
import ReactDOM from 'react-dom';
import './scss/templates/collection.scss';
import Collection from './apps/collection-rectrek/Collection';
import OVApp from './utils/OVContext';
import { jsx as _jsx } from "react/jsx-runtime";
var _window$OV = window.OV,
    COLLECTION = _window$OV.COLLECTION,
    COLLECTION_ID = _window$OV.COLLECTION_ID;
var gridDisplaySwatches = COLLECTION.gridDisplaySwatches;
var paletteFilterParam = 'paletteFilter';

var init = function init() {
  var banner = _objectSpread(_objectSpread({}, COLLECTION), {}, {
    component: 'TEXT_ONLY'
  });

  var urlParams = new URLSearchParams(window.location.search);
  var paletteParam = urlParams.get(paletteFilterParam);
  ReactDOM.render( /*#__PURE__*/_jsx(OVApp, {
    children: /*#__PURE__*/_jsx(Collection, {
      banner: banner,
      displaySwatches: gridDisplaySwatches,
      shopifyId: COLLECTION_ID,
      paletteParam: paletteParam
    })
  }), document.getElementById('collection'));
};

init();